// extracted by mini-css-extract-plugin
module.exports = {"banner-container":"Header_banner-container__2KHrG"};